import { ReactNode } from "react";
import { create } from "zustand";

type IAlertProps = {
  title?: string;
  isOpen: boolean;
  inner?: string;
  innerHtml?: ReactNode | null;
  chkBnt?: boolean;
  cnclBtn?: boolean;
  chkTxt?: string;
  onSetConfirm?: () => void;
};

interface SetAlertState {
  title?: string;
  isOpen: boolean;
  inner?: string;
  innerHtml?: ReactNode | null;
  chkBnt?: boolean;
  cnclBtn?: boolean;
  chkTxt?: string;

  setIsOpen: (isOpen: boolean) => void;
  onSetConfirm: () => void; // 확인 handle
  onSetAlert: ({
    title,
    isOpen,
    inner,
    innerHtml,
    chkBnt,
    cnclBtn,
    chkTxt,
    onSetConfirm,
  }: IAlertProps) => void;
}

const useAlertStore = create<SetAlertState>((set) => ({
  title: "",
  isOpen: false,
  inner: "",
  innerHtml: null,
  chkBnt: true,
  cnclBtn: false,
  chkTxt: "btn_confirm",

  setIsOpen: (isOpen) => {
    set({ isOpen: isOpen });
  },

  onSetConfirm: () => {},

  onSetAlert: ({
    title,
    isOpen,
    inner,
    innerHtml,
    chkBnt,
    cnclBtn,
    chkTxt,
    onSetConfirm,
  }: IAlertProps) => {
    set({
      title,
      isOpen,
      inner,
      innerHtml,
      cnclBtn,
      chkBnt,
      onSetConfirm,
    });
    if (!!chkTxt) {
      set({ chkTxt });
    }
  },
}));

export default useAlertStore;
